<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     模型发布
  +---------------------------------------------------------------------------------------
-->

<template>
  <div class="home-publish theme-dark flex-center">
    <div v-if="!publishing" class="publish-preview">
      <div class="left">
        <div class="font-8x text-primary">
          <i class="iconfont icon-logo"></i>
        </div>
        <div class="mt pl pr">{{ dev.dev_name }}</div>
      </div>
      <div class="center flex-center column">
        <img src="@/assets/arrow-right-long.svg" style="width: 320px; height: 100px;" />
        <div class="mb-lg">
          <div>
            <span>最近更新时间：</span>
            <span>{{ dev.cmd_updatetime | parseTime }}</span>
          </div>
          <div>
            <span>最近发布时间：</span>
            <span
              v-if="dev.last_sync_time"
              :class="{ 'text-danger': dev.cmd_updatetime > dev.last_sync_time }"
            >{{ dev.last_sync_time | parseTime }}</span>
            <span v-else class>无</span>
          </div>
        </div>
        <el-button
          v-if="dev.cmd_updatetime <= dev.last_sync_time"
          type="default"
          round
          plain
          :loading="publishing"
          @click="submit"
        >已是最新</el-button>
        <el-button v-else type="danger" round :loading="publishing" @click="submit">立即发布</el-button>
      </div>
      <div class="right">
        <div class="font-8x text-primary">
          <i class="iconfont icon-dtu-b"></i>
        </div>
        <div class="mt pl pr">{{ dev.dev_total }} 台设备</div>
      </div>
    </div>

    <div v-else class="publish-syncing flex-center column">
      <rainbow-loading />
      <div class="text-center">正在同步模型，已完成 {{ success_count + ' / ' + total_count }} ......</div>
    </div>
  </div>
</template>

<script>
import { syncDevApi, querySyncDevApi } from "@/api/devApi";

export default {
  name: "HomePublish",

  components: {
    RainbowLoading: () => import("./components/RainbowLoading"),
  },

  data() {
    return {
      publishing: false,
      inter1: null,
      sync_status: 1, //同步状态：0=待同步，1=同步中，2=同步完成，-1=同步失败或取消
      success_count: 0, //同步成功数
      total_count: 0, //设备总数

      querying: false,
    };
  },

  computed: {
    dev() {
      return this.$store.state.devStore.dev;
    },
  },

  created() {
    querySyncDevApi({ devid: this.dev.devid }).then((res) => {
      if (!res.errno) {
        this.sync_status = res.data.sync_status; //同步状态：0=待同步，1=同步中，2=同步完成，-1=同步失败或取消
        this.total_count = res.data.total_count;
        if (this.sync_status == 0 || this.sync_status == 1) {
          this.success_count = res.data.success_count;
          this.publishing = true;
          this.queryStatus();
        }
      }
    });
  },

  beforeDestroy() {
    if (this.inter1) {
      clearInterval(this.inter1);
    }
    this.inter1 = null;
    this.sync_status = 0; //同步状态：0=待同步，1=同步中，2=同步完成，-1=同步失败或取消
    this.success_count = 0;
    this.total_count = 0;
  },

  methods: {
    submit() {
      var _this = this;
      this.total_count = this.dev.dev_total;
      this.publishing = true;
      let loading = this.$loading({
        lock: true,
        text: "",
        spinner: "null",
        background: "transparent",
      });
      syncDevApi({ devid: this.dev.devid })
        .then((res) => {
          if (!res.errno) {
            this.queryStatus(loading);
          } else {
            loading.close();
            _this.publishing = false;
            _this.$message.error(res.message);
          }
        })
        .catch(() => {
          loading.close();
          _this.publishing = false;
          _this.$message.error("同步失败");
        });
    },

    queryStatus(loading) {
      if (!loading)
        loading = this.$loading({
          lock: true,
          text: "",
          spinner: "null",
          background: "transparent",
        });
      let _this = this;

      _this.inter1 = setInterval(() => {
        //判断是否在请求中
        if (!_this.querying) {
          _this.querying = true;
          querySyncDevApi({ devid: this.dev.devid }).then((res) => {
            _this.querying = false;
            if (!res.errno) {
              _this.sync_status = res.data.sync_status; //同步状态：0=待同步，1=同步中，2=同步完成，-1=同步失败或取消
              _this.success_count = res.data.success_count;
              _this.total_count = res.data.total_count;
              //请求成功得到结果
              if (_this.sync_status != 1 && _this.sync_status != 0) {
                clearInterval(_this.inter1);
                _this.inter1 = null;
                setTimeout(() => {
                  _this.publishing = false;
                  _this.sync_status = 0; //同步状态：0=待同步，1=同步中，2=同步完成，-1=同步失败或取消
                  _this.success_count = 0;
                  _this.total_count = 0;
                }, 300);

                loading.close();
                if (_this.sync_status == 2) {
                  _this.$message.success("同步成功！");
                  _this.$store.dispatch("fetchDataAction");
                } else if (_this.sync_status == -1) {
                  _this.$message.error("同步失败");
                }
              }
            } else {
              loading.close();
              _this.$message.error("同步失败");
              _this.publishing = false;
            }
          });
        }
      }, 1000);
    },
  },
};
</script>

<style lang="scss" scoped>
.home-publish {
  height: 100%;
  .publish-preview {
    margin-top: -100px;
    display: flex;
    .left,
    .right {
      width: 130px;
      text-align: center;
    }
  }
  .publish-syncing {
    margin-top: -100px;
  }
}
</style>
